import React from "react";
import { motion } from "framer-motion";

export const PricingHero = () => {
  return (
    <section
      data-testid="pricing-hero"
      className="relative pt-32 sm:pt-40 lg:pt-48 pb-16 sm:pb-24 bg-[#09090b] overflow-hidden"
    >
      {/* Floating background gradients */}
      <div className="pointer-events-none absolute inset-0 -z-0">
        <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-white/[0.035] blur-[140px]" />
        <div className="absolute top-20 right-0 w-[480px] h-[480px] rounded-full bg-white/[0.025] blur-[120px]" />
      </div>

      <div className="relative mx-auto w-full px-[5vw]">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.12 } },
          }}
          className="max-w-4xl"
        >
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20, filter: "blur(6px)" },
              show: {
                opacity: 1,
                y: 0,
                filter: "blur(0px)",
                transition: { duration: 0.7 },
              },
            }}
            className="font-heading text-[11px] tracking-widest uppercase text-white/40 mb-6"
          >
            <span className="inline-block h-px w-8 align-middle mr-3 bg-white/30" />
            Pricing
          </motion.p>

          <motion.h1
            variants={{
              hidden: { opacity: 0, y: 30, filter: "blur(8px)" },
              show: {
                opacity: 1,
                y: 0,
                filter: "blur(0px)",
                transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1] },
              },
            }}
            className="font-title font-medium text-white leading-[1.1] tracking-tight text-4xl sm:text-5xl lg:text-6xl"
          >
            Websites that <br className="hidden sm:block" />
            <span className="text-white/60">win better jobs.</span>
          </motion.h1>

          <motion.p
            variants={{
              hidden: { opacity: 0, y: 18 },
              show: { opacity: 1, y: 0, transition: { duration: 0.7 } },
            }}
            className="mt-8 sm:mt-10 text-[16px] sm:text-lg text-white/60 max-w-2xl leading-relaxed"
          >
            One package, built for building firms — everything you need to
            look like the premium choice and turn homeowners into quote
            requests from day one.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingHero;
